import { useTitlesApi } from '@api/hooks/useTitlesApi';
import useLoad, { LoadOptions } from '@hooks/useLoad';
import useSubscriber from '@hooks/useSubscriber';
import { useIsNewIngest } from '@hooks/useTitlesDataSource';
import { PlaybackOptionDetailed } from '@models/Title';

const usePlaybackOptionQuery = (
  playbackOptionId?: string,
  options: LoadOptions<PlaybackOptionDetailed> | undefined = { refetchOnDisableCache: true },
  viewAsSubscriber?: boolean
) => {
  const isNewIngest = useIsNewIngest();
  const { getPlaybackOption } = useTitlesApi();
  const { subscriber } = useSubscriber();
  const subscriberId = viewAsSubscriber ? subscriber?.subscriberId : undefined;

  return useLoad(
    () => getPlaybackOption(playbackOptionId || '', subscriberId),
    [
      'playback-option',
      playbackOptionId,
      ...(subscriberId ? [subscriberId] : []),
      ...(isNewIngest ? ['new-ingest'] : []),
    ],
    {
      ...options,
      enabled: Boolean(playbackOptionId) && options?.enabled !== false,
      staleTime: Infinity,
    }
  );
};

export default usePlaybackOptionQuery;
